<template>
  <div class="deals-page">
    <div class="header"></div>
    <archived v-if="isAccess" />
    <login-required v-if="!isAccess" />
  </div>
</template>

<script>
import Archived from '@/components/deals/archived'
import LoginRequired from '@/components/common/login-required'

export default {
  name: 'deals',
  components: {
    Archived,
    LoginRequired
  },
  computed: {
    isAccess () {
      return this.$store.getters['tokens/isAccessToken']
    }
  }
}
</script>

<style lang="scss" scoped>
.deals-page {
  padding-top: 150px;
  .header {
    height: 75px;
    background-color: rgb(24, 48, 90);
    width: 100%;
    position: absolute;
    top: 0;
  }
}
</style>
